export default __webpack_public_path__ + "bullet-list.png";